<template>
  <div class="col-auto">
    <model-table
      :collection="pagerRequestTypes"
      :columns="[
        { field: 'id' },
        { name: 'Internal Name', field: 'name' },
        { field: 'displayName' },
        { name: 'icon', field: row => ({ name: row.icon, color: row.color }), component: 'icon' },
        { name: 'deliveryLocations', field: row => $_.map(row.deliveryLocations.data, 'name'), component: 'chips', limitValues: 4 },
        { name: 'library', component: 'library-link', hide: currentCircuit.isLibrary },
        { name: 'actions', align: 'right' }
      ]"
      orderable
      :has-library="!currentCircuit.isLibrary"
      :library-collection="pagerRequestTypeLibrary"
      :library-columns="[
        { field: 'name' },
        { field: 'displayName' },
        { name: 'icon', field: row => ({ name: row.icon, color: row.color }), component: 'icon' },
        { name: 'deliveryLocations', field: row => $_.map(row.deliveryLocations.data, 'name'), component: 'chips', limitValues: 6 }
      ]"
      :link-filter="libraryFilterFunction"
    >
      <pager-request-type-form />
    </model-table>
  </div>
</template>

<script>

import ModelTable from 'src/modules/admin/components/ModelTable'
import PagerRequestTypeForm from 'src/modules/admin/pager-request/PagerRequestTypeForm'

export default {
  name: 'PagerRequestTypeTable',
  components: {
    ModelTable,
    PagerRequestTypeForm
  },
  configuration: ['currentCircuit'],
  models: {
    pagerRequestTypes: {
      deliveryLocations: 'default',
      libraryParentId: true,
      receiveLibraryUpdates: true
    },
    pagerRequestTypeLibrary: {
      deliveryLocations: 'default',
      libraryChildSiteIds: true,
      variables () {
        return {
          searchString: this.libraryFilterString,
          limit: 10
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      libraryFilterString: null
    }
  },
  methods: {
    libraryFilterFunction (value) {
      this.libraryFilterString = !_.isEmpty(value) ? value.trim() : null
    }
  }
}

</script>
